import { InvitationQuotaTypeEnum } from '@/gql/myomr'

type InvitationQuotaLike = {
  kind: InvitationQuotaTypeEnum
}

type SupportedInvitationQuota<T extends InvitationQuotaLike> = T & {
  kind: Exclude<T['kind'], InvitationQuotaTypeEnum.ExternalQuota>
}

export function isSupportedInvitationQuota<T extends InvitationQuotaLike>(
  quota: T | null | undefined,
): quota is SupportedInvitationQuota<T> {
  return quota != null && quota.kind !== InvitationQuotaTypeEnum.ExternalQuota
}

export function filterSupportedInvitationQuotas<T extends InvitationQuotaLike>(invitationQuotas: T[]): SupportedInvitationQuota<T>[] {
  return invitationQuotas.filter(isSupportedInvitationQuota)
}
